.wrapper {
  height: 100%;
  min-height: 700px;
  display: flex;
  flex-direction: column;
  color: #1a1a1a;
}

.wrapper :global(.rbc-calendar) {
  flex: 1;
  background: #ffffff;
  border-radius: 12px;
  padding: 12px;
  font-family: inherit;
  color: #1a1a1a;
}

.wrapper :global(.rbc-toolbar) {
  color: #1a1a1a;
  margin-bottom: 12px;
}

.wrapper :global(.rbc-toolbar button) {
  background: #f4f4f6;
  color: #1a1a1a;
  border: 1px solid #e2e2e6;
  border-radius: 6px;
  padding: 4px 10px;
}

.wrapper :global(.rbc-toolbar button:hover),
.wrapper :global(.rbc-toolbar button.rbc-active) {
  background: #a084e8;
  color: #ffffff;
  border-color: #a084e8;
}

.wrapper :global(.rbc-time-view),
.wrapper :global(.rbc-time-header),
.wrapper :global(.rbc-time-content),
.wrapper :global(.rbc-day-slot),
.wrapper :global(.rbc-timeslot-group),
.wrapper :global(.rbc-time-slot),
.wrapper :global(.rbc-header) {
  border-color: #e2e2e6;
}

.wrapper :global(.rbc-time-content) {
  max-height: 700px;
  overflow-y: auto;
}

.wrapper :global(.rbc-time-header-content),
.wrapper :global(.rbc-header) {
  background: #ffffff;
  color: #1a1a1a;
  padding: 6px 4px;
}

.colHeader {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.colHeaderLabel {
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
}

.colHeaderTotal {
  display: inline-block;
  background: #ede6ff;
  color: #4a3fb3;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 999px;
  font-variant-numeric: tabular-nums;
}

.wrapper :global(.rbc-today) {
  background: #f7f4ff;
}

.wrapper :global(.rbc-label),
.wrapper :global(.rbc-time-gutter) {
  color: #6b6b76;
}

.wrapper :global(.rbc-current-time-indicator) {
  background-color: #ff4d6d;
  height: 2px;
}

.wrapper :global(.rbc-event) {
  border-radius: 4px;
  padding: 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  min-height: 14px;
}

/* Keep resource columns equal width. Without min-width:0 a flex column grows to
   fit a long all-day event title (white-space: nowrap), stretching the column
   instead of letting the title truncate. */
.wrapper :global(.rbc-time-header-content) {
  min-width: 0;
}

.wrapper :global(.rbc-allday-cell .rbc-row-segment) {
  min-width: 0;
}

/* Week-view date headers wrap the label in a fixed-height button that clipped
   the totals pill stacked beneath it. Give the row room and let it show. */
.wrapper :global(.rbc-time-header-cell) {
  min-height: 48px;
}

.wrapper :global(.rbc-time-header .rbc-header) {
  overflow: visible;
}

.wrapper :global(.rbc-event-label) {
  display: none;
}

.wrapper :global(.rbc-event.rbc-selected) {
  box-shadow: 0 0 0 2px #a084e8;
}

.wrapper :global(.rbc-event-content) {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
}

.eventInner {
  display: flex;
  align-items: center;
  padding: 1px 6px;
  font-size: 11px;
  line-height: 1.15;
  height: 100%;
  width: 100%;
  overflow: hidden;
  border-left: 3px solid;
}

.billable {
  background: #ede6ff;
  border: 1px solid #9d83df;
  color: #1a1a1a;
}
.billable .eventInner {
  border-left-color: #6e68cc;
}

.nonBillable {
  background: #eef0f4;
  border: 1px solid #9aa0ad;
  color: #1a1a1a;
}
.nonBillable .eventInner {
  border-left-color: #6b6b76;
}

.eventTitle {
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #0c0c0c;
  flex: 1;
  min-width: 0;
}
